/**
 * Maoni automatic free gift logic.
 *
 * Keeps exactly one configured gift variant in the cart while the value of
 * all non-gift line items reaches the configured threshold. The gift is
 * removed again as soon as the eligible value drops below the threshold.
 */
(function initMaoniFreeGift() {
  const configElement = document.getElementById('MaoniFreeGiftConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[Maoni Gratisgeschenk] Konfiguration konnte nicht gelesen werden.', error);
    return;
  }

  const variantId = Number(config.variantId);
  const threshold = Number(config.threshold);
  if (!variantId || !threshold) return;

  const root = window.Shopify && window.Shopify.routes
    ? window.Shopify.routes.root
    : '/';
  const cartUrl = `${root}cart.js`;
  const addUrl = `${root}cart/add.js`;
  const updateUrl = `${root}cart/update.js`;

  let timer;
  let running = false;
  let runAgain = false;

  const requestJson = async (url, options = {}) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(options.body ? { 'Content-Type': 'application/json' } : {})
      },
      ...options
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(`${response.status}: ${message}`);
    }
    return response.json();
  };

  const refreshCartUi = () => {
    document.dispatchEvent(new CustomEvent('on:cart:change', {
      bubbles: true,
      cancelable: false
    }));
  };

  const reconcile = async () => {
    if (running) {
      runAgain = true;
      return;
    }

    running = true;
    try {
      const cart = await requestJson(cartUrl);
      const giftLines = cart.items.filter((item) => Number(item.variant_id) === variantId);
      const eligibleValue = cart.items.reduce((sum, item) => {
        if (Number(item.variant_id) === variantId) return sum;
        return sum + Number(item.final_line_price || 0);
      }, 0);
      const shouldContainGift = config.available && eligibleValue >= threshold;
      const updates = {};

      if (shouldContainGift && giftLines.length === 0) {
        await requestJson(addUrl, {
          method: 'POST',
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: { _maoni_gratisgeschenk: 'true' }
            }]
          })
        });
        refreshCartUi();
      } else if (shouldContainGift) {
        giftLines.forEach((line, index) => {
          const wantedQuantity = index === 0 ? 1 : 0;
          if (Number(line.quantity) !== wantedQuantity) {
            updates[line.key] = wantedQuantity;
          }
        });
      } else {
        giftLines.forEach((line) => {
          updates[line.key] = 0;
        });
      }

      if (Object.keys(updates).length > 0) {
        await requestJson(updateUrl, {
          method: 'POST',
          body: JSON.stringify({ updates })
        });
        refreshCartUi();
      }
    } catch (error) {
      console.warn('[Maoni Gratisgeschenk] Warenkorb konnte nicht synchronisiert werden.', error);
    } finally {
      running = false;
      if (runAgain) {
        runAgain = false;
        schedule(80);
      }
    }
  };

  const schedule = (delay = 120) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, delay);
  };

  document.addEventListener('on:cart:add', () => schedule(40));
  document.addEventListener('on:cart:change', () => schedule(80));
  document.addEventListener('on:cart:after-merge', () => schedule(120));
  document.addEventListener('on:cart-drawer:before-open', () => schedule(0));
  window.addEventListener('pageshow', () => schedule(0));
  schedule(0);
}());
